// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__15pdQ","box":"WorkspacesBox_box__3s2O6","node":"WorkspacesBox_node__10hQ2"};